<template>
    <div>
        <div class="donut-chart-container">
            <div class="chart-wrapper">
                <doughnut-chart :chart-data="chartData" :options="chartOptions" />
                <div class="center-text">{{ centerText }}%</div>
            </div>
            <div class="legend">
                <h4>{{ title }}</h4>
                <ul>
                    <li v-for="(label, i) in chartData.labels" :key="i" class="text">
                        <span :style="{ backgroundColor: chartData.datasets[0].backgroundColor[i] }"></span>
                        <b class="percentage">{{ getPercentage(i) }}%</b>
                        <span class="label-text">{{ label }}</span>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
    name: 'DoughnutChartError',
    components: {
        doughnutChart: {
            extends: Doughnut,
            mixins: [reactiveProp],
            props: ['options'],
            mounted() {
                this.renderChart(this.chartData, this.options);
            },
            watch: {
                chartData() {
                    this.renderChart(this.chartData, this.options);
                }
            }
        },
    },
    props: {
        chartData: Object,
        centerText: {
            type: [String, Number],
            default: ''
        },
        title:{
            type: [String],
            default: ''
        }
    },
    computed: {
        chartOptions() {
            return {
                cutoutPercentage: 55,
                responsive: true,
                maintainAspectRatio: true,
                legend: { display: false },
                tooltips: { enabled: false },
                plugins: {

                    datalabels: {
                        color: '#fff',
                        font: { weight: 'bold' },
                        formatter: (value, context) => {
                            const data = context.chart.data.datasets[0].data;
                            const total = data.reduce((sum, val) => sum + val, 0);
                            const percentage = ((value / total) * 100).toFixed(0);
                            return `${percentage}%`;
                        }
                    }
                }
            };
        }
    },
    methods: {
        getPercentage(index) {
            const data = this.chartData.datasets[0].data;
            const total = data.reduce((acc, val) => acc + val, 0);
            const value = data[index];
            return ((value / total) * 100).toFixed(2);
        }
    }
};
</script>


<style scoped>
.donut-chart-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 10px;
    height: 100%;
}

.chart-wrapper {
    position: relative;
    width: 200px;
    height: 200px;
    flex-shrink: 0;
}

.center-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    font-weight: bold;
    color: #000;
}

.legend {
    flex: 1 1 250px;
    min-width: 200px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
}

.legend h4 {
    margin: 0 0 10px;
    font-size: 14px;
    text-align: left;
}

.legend ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.legend-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 1.4;
}

.color-box {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 8px;
    margin-top: 4px;
    border-radius: 2px;
    flex-shrink: 0;
}

.legend li {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    font-size: 12px;
    line-height: 1.2;
    flex-wrap: wrap;
}

.legend li span {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    border-radius: 2px;
    flex-shrink: 0;
}

.legend li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    font-size: 12px;
    line-height: 1.4;
    flex-wrap: nowrap;
}

.legend li span {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 8px;
    border-radius: 2px;
}

.percentage {
    flex: 0 0 30px;
    text-align: right;
    margin-right: 8px;
    line-height: 1.4;
    font-weight: bold;
}

.label-text {
    flex: 1;
    white-space: normal;
    line-height: 1.4;
}
@media (min-width: 2560px) {
  .chart-wrapper {
    position: relative;
    width: 400px;
    height: 400px;
    flex-shrink: 0;
    }
}
@media (max-width: 768) {}
@media (max-width: 600px) {
    .donut-chart-container {
        flex-direction: column;
        align-items: center;
    }

    .legend {
        text-align: center;
    }
    
    .legend{
        flex: 1 1;
        min-width: 200px;
        max-width: 100%;
        display: flex;
        flex-direction: column;
    }
    .legend-item {
        justify-content: center;
        text-align: left;
    }

    .legend h4 {
        text-align: center;
    }

    .percentage {
        text-align: right;
    }

    .label-text {
        text-align: left;
    }
}

</style>
